module.exports = __webpack_public_path__ + "img/folder.fd7d784a.svg";